import MainMenu from '@/components/foundation/main-menu/MainMenu'
import EventRms from '@/view/event-rms/EventRms'

export const EventRmsRoute = {
  path: '/event/rms/:id',
  name: 'EventRms',
  components: {
    default: EventRms,
    mainMenu: MainMenu
  },
  meta: {
    auth: true,
    mainArea: 'event',
    area: 'event',
    breadcrumb: [
      {
        name: 'Evento',
        link: '/event'
      },
      {
        eventCode: 'Events/EVENT_CODE',
        isOpenClose: 'Events/IS_OPEN_CLOSE',
        clientName: 'Events/CLIENT_NAME',
        eventIdentification: 'Events/EVENT_IDENTIFICATION',
        linkGetter: 'Events/GET_EVENT_LINK'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/router/event/EventRms.js